import {
  CommonVariableDefinitionType,
  VariableDefinitionType,
} from 'pages/AutomationEngine/types/automation';

import { VariableSourceComponent } from 'pages/AutomationEngine/dialogs/VariableWizard/types';

import * as StaticVariable from './StaticVariable';
import * as LoggedActivityVariable from './LoggedActivityVariable';
import * as ActivityPastDueVariable from './ActivityPastDueVariable';
import * as FieldValueVariable from './FieldValue';
import * as TriggerTimeVariable from './TriggerTimeVariable';
import * as WebhookVariable from './WebhookVariable';

const Lookup: Record<VariableDefinitionType, VariableSourceComponent> = {
  static: StaticVariable,
  logged_activity_trigger: LoggedActivityVariable,
  activity_past_due_trigger: ActivityPastDueVariable,
  field_value: FieldValueVariable,
  trigger_time: TriggerTimeVariable,
  webhook_trigger: WebhookVariable,
};

export const isVariableDefinitionType = (
  type: CommonVariableDefinitionType
): type is VariableDefinitionType => Object.hasOwn(Lookup, type);

export const getSourceLookUp = (type: CommonVariableDefinitionType) =>
  isVariableDefinitionType(type) ? Lookup[type] : undefined;

export default Lookup;
